import { render } from "./historyBack.vue?vue&type=template&id=eb9168d4&scoped=true&ts=true"
import script from "./historyBack.vue?vue&type=script&lang=ts"
export * from "./historyBack.vue?vue&type=script&lang=ts"

import "./historyBack.vue?vue&type=style&index=0&id=eb9168d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb9168d4"]])

export default __exports__